module.exports = __webpack_public_path__ + "static/img/banner3-1.a59fa96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner3-1.jpg
// module id = 7xzb
// module chunks = 1